/**
 * Pan slot component.
 */
export const Pan = () => null;

Pan['displayName'] = 'Pan';
